import { getPracticeNameFromId } from "../../../../lib/labels";
import { formatCurrency } from "../../../../lib/script";

export default function PaymentsTablePractices({item}) {

    // const [messageText,setMessageText] = useState(null)

    // useEffect(() => {
    //     let a = []

    //     item.practices.forEach((practice, index) => {
    //         a.push(`<div className="practice_amount">                                        
    //             <span>${getPracticeNameFromId(practice.practice_id)}</span>
    //             <span>${formatCurrency(practice.amount)}</span>
    //         </div>`)
    //     })
    //     setMessageText(a.join(''))
    // }, [])


    // let mText = <div>
    //     {item.practices.map(practice => (
    //         <div className="" key={practice.practice_id}>                                        
    //             <span>${getPracticeNameFromId(practice.practice_id)}</span>
    //             <span>${formatCurrency(practice.amount)}</span>
    //         </div>
    //     ))}
    // </div>
    return <>
        {item.practices.map((practice, index) => (
            <span key={practice.practice_id}>                                        
                {getPracticeNameFromId(practice.practice_id)} (${formatCurrency(practice.amount)})
                {index !== (item.practices.length-1) && <>, </>}    
            </span>
        ))}
    </>

    // return <HoverWrapperInfo blueStyle={true} htmlText={true} modalText={messageText} >
    //     {item.practices.map((practice, index) => (
    //         <span key={practice.practice_id}>                                        
    //             {getPracticeNameFromId(practice.practice_id)}
    //             {index !== (item.practices.length-1) && <>, </>}    
    //         </span>
    //     ))}
    // </HoverWrapperInfo>
}